import "ts-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider } from "@apollo/client";

console.log("Index.tsx is loading...");
console.log("React version:", React.version);
console.log("Environment:", import.meta.env);
// import { ApolloProvider as ApolloHooksProvider } from "@apollo/react-hooks";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import LocaleContextProvider from "./components/locale-context-provider";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import theme from "./theme";
import { supportedLocales, defaultLocale } from "./locale";
import { createApolloClient } from "./apollo";

import "./index.css";
import AuthContextProvider from "./components/auth-context-provider";
import "isomorphic-fetch";

const language: string =
  localStorage.getItem("locale") ||
  (navigator.languages && navigator.languages[0]) ||
  navigator.language;

// console.log("localeeeeeeeeeessssssss");
// console.log(localStorage.getItem("locale"));

const currentLocale: string = supportedLocales.includes(language)
  ? language
  : defaultLocale;

// Limpiar service workers viejos al cargar
serviceWorker.unregister();

const Root = () => {
  // Clear the HTML loading timeout since React has mounted
  if ((window as any).__footikTimeout) {
    clearTimeout((window as any).__footikTimeout);
  }
  return <App />;
};

// Función para inicializar la aplicación de forma asíncrona
const initializeApp = async () => {
  console.log("🔄 Initializing Apollo Client...");
  const client = await createApolloClient();
  console.log("✅ Apollo Client initialized");

  ReactDOM.render(
    <ApolloProvider client={client}>
      {/* <ApolloHooksProvider client={client}> */}
      <ThemeProvider theme={theme}>
        <LocaleContextProvider locale={currentLocale}>
          <AuthContextProvider apolloCache={client.cache}>
            <Root />
          </AuthContextProvider>
        </LocaleContextProvider>
      </ThemeProvider>
      {/* </ApolloHooksProvider> */}
    </ApolloProvider>,
    document.getElementById("root")
  );
};

// Inicializar la aplicación
initializeApp().catch(error => {
  console.error("❌ Failed to initialize app:", error);
  // Show error to user - don't leave a blank screen
  const loading = document.getElementById('app-loading');
  if (loading) {
    loading.innerHTML = '<div style="text-align:center;padding:20px;">' +
      '<p style="font-family:sans-serif;color:#757575;font-size:14px;">Error loading app. Please reload.</p>' +
      '<button onclick="sessionStorage.clear();window.location.replace(\'/\')" style="margin-top:12px;padding:10px 20px;background:#00BCD4;color:white;border:none;border-radius:8px;font-size:14px;cursor:pointer;">Reload</button>' +
      '</div>';
  }
});
